import { trpcBillingCreateCheckoutPaymentMethod } from '@trashlab/api/src/generated/hooks';

type UseCreateCheckoutPaymentMethodInput = {
  cartId: string;
  tenantId: string;
  onError: (message: string) => void;
};

export function useCreateCheckoutPaymentMethod({
  cartId,
  tenantId,
  onError,
}: UseCreateCheckoutPaymentMethodInput) {
  const mutation = trpcBillingCreateCheckoutPaymentMethod.useMutation({
    useErrorBoundary: false,
    onError: async (error) => onError(error.message),
  });

  return (externalId: string) =>
    mutation.mutateAsync({
      externalId,
      tenantId,
      cartId,
    });
}
